import React from "react";
import postDoc from "../../../services/Documents/postDoc";
import getDocs from "../../../services/Documents/getDocsData";
import { Upload, X, FileText } from "lucide-react";

export const UploadPdfModal = ({
  setPdf,
  setAddStatus,
  setPdfName,
  closeAddModal,
  pdf,
  pdfName,
  setDocuments,
  addStatus,
  userId,
  parentFolderId,
}) => {
  const handlePdfFileChange = (e) => {
    if (e.target.files[0]) {
      setPdf(e.target.files[0]);
      setAddStatus("");
      // Auto-populate the name field with the file name (without extension)
      const fileName = e.target.files[0].name;
      const nameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
      setPdfName(nameWithoutExtension);
    }
  };

  const handlePdfNameChange = (e) => {
    setPdfName(e.target.value);
  };

  const handleAddPdf = async (e) => {
    e.preventDefault();

    if (!pdf) {
      setAddStatus("Please select a PDF file");
      return;
    }

    if (!pdfName.trim()) {
      setAddStatus("Please enter a name for the document");
      return;
    }

    try {
      setAddStatus("Uploading document...");

      const formData = new FormData();
      formData.append("pdf", pdf);
      formData.append("name", pdfName);
      if(parentFolderId !== null) formData.append("parentFolderId", parentFolderId);

      const uploadPdfResponse = await postDoc(userId, formData);

      if (uploadPdfResponse) {
        setAddStatus("Document uploaded successfully");

        // Refresh the documents list after successful upload
        setTimeout(async () => {
          const docs = await getDocs(userId);
          setDocuments(docs);
          closeAddModal();
        }, 1500);
      } else {
        setAddStatus("Failed to upload document");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setAddStatus("An error occurred while uploading the document");
    }
    console.log("Uploading document...");
  };

  return (
    <div className="fixed inset-0 bg-[#1A365D] bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl border-4 border-[#D4AF37] relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1 bg-[#D4AF37]"></div>
        <button
          onClick={closeAddModal}
          className="absolute top-4 right-4 text-[#1A365D] hover:text-[#D4AF37] transition duration-300"
        >
          <X size={24} />
        </button>

        <div className="p-6">
          <h3 className="text-2xl font-bold mb-6 text-[#1A365D] flex items-center">
            <FileText className="mr-3 text-[#D4AF37]" size={28} />
            Añadir un Documento
          </h3>

          <form onSubmit={handleAddPdf}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-[#1A365D] mb-2">
                Archivo PDF
              </label>
              <div className="flex items-center">
                <input
                  type="file"
                  accept=".pdf"
                  onChange={handlePdfFileChange}
                  className="w-full px-3 py-2 border border-[#1A365D] border-opacity-30 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
                />
              </div>
              {pdf && (
                <p className="mt-1 text-sm text-gray-600">
                  Seleccionado: {pdf.name} ({Math.round(pdf.size / 1024)} KB)
                </p>
              )}
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-[#1A365D] mb-2">
                Nombre del Documento
              </label>
              <input
                type="text"
                value={pdfName}
                onChange={handlePdfNameChange}
                placeholder="Ingrese un nombre para este documento"
                className="w-full px-3 py-2 border border-[#1A365D] border-opacity-30 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
              />
            </div>

            <button
              type="submit"
              className="w-full py-3 px-4 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold rounded-md transition duration-300 ease-in-out transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] flex items-center justify-center"
            >
              <Upload size={20} className="mr-2" />
              Subir Documento
            </button>
          </form>

          {addStatus && (
            <div
              className={`mt-4 p-3 rounded-md text-center font-medium ${
                addStatus.includes("successfully")
                  ? "bg-green-100 text-green-800"
                  : addStatus.includes("Failed") ||
                    addStatus.includes("Please") ||
                    addStatus.includes("error")
                  ? "bg-red-100 text-red-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {addStatus}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};